var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Align-Front-1--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Align Front 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-front-1--design-front-layer-layers-pile-stack-arrange-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#131f2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4 13.5 8.5 0c0.5523 0 1 -0.4477 1 -1l0 -8.5c0 -0.55229 -0.4477 -1 -1 -1L4 3c-0.55229 0 -1 0.44771 -1 1l0 8.5c0 0.5523 0.44771 1 1 1Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#131f2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5 10.5v-9c0 -0.26522 0.105357 -0.51957 0.292893 -0.707107C0.98043 0.605357 1.23478 0.5 1.5 0.5h9",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.2c63b480a279ca424448c56ff9482aee.svg";
export { ForwardRef as ReactComponent };